var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 18",
    style: {
      enableBackground: "new 0 0 14 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,0.5v17h8.2c2.6,0,4.7-2.1,4.7-4.7V0.5H0.5z M12.3,12.8c0,2-1.6,3.7-3.7,3.7H1.5v-15h10.8V12.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.1,
    y: 5.4,
    width: 5.6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.1,
    y: 8.2,
    width: 5.6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.1,
    y: 10.9,
    width: 4.2,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.5d3555ce578c6a02a7855107622ad0d4.svg";
export { ForwardRef as ReactComponent };